import { Table as AntTable } from 'antd';
import styled from 'styled-components';
import { TableProps } from './types';

export const TableWrapper = styled.div`
  position: relative;
  .ant-table-container {
    border: none;
  }
`;

export const StyledHeaderBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledTable = styled(AntTable)<TableProps>`
  &.ant-table-wrapper {
    border-radius: 12px;
  }

  .ant-table {
    border-radius: 12px;
    background-color: var(--wl-background, #ffffff);

    font-family:
      'SF Pro Display',
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      'Helvetica Neue',
      Arial,
      'Noto Sans',
      sans-serif !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 100% !important;
    letter-spacing: 0 !important;
    vertical-align: middle !important;
    color: var(--wl-on-background, #191c1e);
  }
  .ant-table-content {
    border-radius: 12px;
  }

  .ant-table-thead > tr > th {
    font-weight: 500 !important;
    white-space: nowrap;
    background-color: var(--wl-surface, #fd5b2c);
    color: var(--wl-on-background, #191c1e);
  }
  .ant-table-tbody > tr > td {
    font-weight: 400 !important;
    white-space: nowrap;
  }

  .ant-table-column-sorters {
    border-left: none !important;
    border-right: none !important;
    width: 100%;
  }

  .ant-table-column:hover .ant-table-column-sorters {
    border-left-color: transparent !important;
    border-right-color: transparent !important;
  }

  .ant-table-cell::before {
    content: unset !important;
  }

  .ant-table-cell-fix-right {
    background-color: var(--wl-background, #ffffff);
  }
  .ant-table-cell-fix-right-first::after {
    box-shadow: none !important;
    border-right: 1px solid var(--wl-primary-color, #fd5b2c);
  }
  .ant-table-row:nth-child(even) .ant-table-cell-fix-right {
    background-color: var(--wl-background, #ffffff);
  }

  .ant-table-row:not(.ant-table-row-selected):hover > td {
    background-color: inherit !important;
  }

  .ant-table-tbody > tr.cursor-pointer:hover > td {
    background-color: color-mix(
      in srgb,
      var(--wl-background, #ffffff) 80%,
      gray
    ) !important;
  }
  .ant-table-container table tr th,
  .ant-table-container table tr td {
    border-right: none !important;
  }
  .ant-table-container::after {
    box-shadow: none !important;
  }

  .ant-table-container::before {
    box-shadow: none !important;
  }

  .ant-table-column-sorters {
    display: inline-flex;
    align-items: center;
    flex-direction: row-reverse;
  }

  .ant-table-column-sorters .ant-table-column-title {
    margin-left: 8px;
    margin-right: 0;
  }

  .ant-table-tbody > tr:nth-child(even) {
    background-color: var(--wl-background, #ffffff);
  }

  .ant-table-tbody > tr:nth-child(odd) {
    background-color: var(--wl-surface, #ffffff);
  }

  .ant-table-tbody > tr.ant-table-row-selected > td {
    background-color: var(--wl-background, #ffffff) !important;
    color: var(--wl-on-background, #191c1e) !important;
    transition: background-color 0.2s ease;
  }
`;
